import { Component, OnInit, Input, Output, EventEmitter , ChangeDetectionStrategy } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-prize-wheel-preview',
    templateUrl: './prize-wheel-preview.component.html',
    styleUrls: ['./prize-wheel-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrizeWheelPreviewComponent implements OnInit {
  title = 'wheel-preview';
  size: any
  rotate: any
  skewY: any
  skewAngle: any;
  myText: number = 0;
  wheelIndex: any = 0;
  noSegmentImage = false;
  roundsRotation = 50;
  playerWinningInfo: any;
  public lightanimUrl: string;
  private WinRotate = 360 * this.roundsRotation;
  readyToLoad = false;
  wheelFrameImgPath = '';
  @Input() configObj;
  @Output() confirmStatus = new EventEmitter<boolean>();

  timeRotate = 12000;
  currentRotate = 0;
  isRotating = false;
  wheel: any;
  spinBlinkingLights = false;

  constructor(private cmnServ: CommonService, private activeModal: NgbActiveModal) {
    this.lightanimUrl = "/bingo_shared_assets/bingo/assets/images/prize_wheel/default_flash_light.png";
    this.wheelFrameImgPath = "/bingo_shared_assets/bingo/assets/images/prize_wheel/default_wheel_frame.png";
  }

  ngOnInit() {
    this.size = this.configObj.regImgs.length;
    this.rotate = 360 / this.size;
    if (this.size == 2) {
      this.skewY = -(90 - this.rotate) * 2;
      this.skewAngle = this.skewY
    } else if (this.size == 3) {
      this.skewY = 90 - this.rotate;
      this.skewAngle = -(this.skewY);
    } else {
      this.skewY = 90 - this.rotate;
      this.skewAngle = this.skewY;
    }

    this.configObj.regImgs.map((item: any, index: any) => {
      const elm = document.createElement('li');
      console.log("PRIZE-WHEEL::::noSegmentImage=>", this.noSegmentImage)
      if (this.noSegmentImage) {
        elm.style.transform = `rotate(${this.rotate * index
          }deg) skewY(-${this.skewY}deg)`;
        elm.innerHTML = `<p style="transform: skewY(${this.skewY}deg) rotate(${this.rotate / 2
          }deg); background-color: ${item.bgColor};"  class= "text text-1">${item.text}
    </p>`;
      } else if (this.size >= 4) {
        let wheel = document.getElementsByClassName('wheel')[0] as HTMLElement;
        elm.style.transform = `rotate(${this.rotate * index
          }deg) skewY(-${this.skewAngle}deg)`;
        if (this.size == 4) {
          wheel.style.width = "31rem";
        }
        elm.innerHTML = `<p style="transform: skewY(${this.skewY}deg) rotate(${this.rotate / 2
          }deg); background-image: url(${item.imageUrl});"  class= "text text-1">
      </p><div style="transform: skewY(${this.skewY}deg) rotate(${this.rotate / 2
          }deg); background-image: url(${item.imageUrl});" class= "text text-1" id="${index}"></div>`;
      } else {
        elm.style.transform = `rotate(${this.rotate * index}deg)`;
        elm.style.transformOrigin = '50% 50%';
        elm.style.width = '100%';
        elm.style.height = '100%';
        if (this.size == 3) {
          elm.innerHTML = `<p style="transform: rotate(${this.rotate / 2}deg); background-image: url(${item.imageUrl});" class= "segment segment3-${index}" id="${index}">
      </p>`;
        } else {
          elm.innerHTML = `<p style="transform: rotate(${this.rotate / 2}deg); background-image: url(${item.imageUrl});" class= "segment" id="${index}">
      </p>`;
        }
      }
      this.wheel = document.getElementsByClassName('wheel')[0] as HTMLElement;
      this.wheel.appendChild(elm);
    });
  }
  public rotateWheel() {
    this.isRotating = (this.isRotating) ? false : true;
    this.start();
  }

  public start() {
    this.isRotating = true;
    this.currentRotate += 360 * 10;
    this.startRotate(this.currentRotate, Math.floor(Math.random() * this.configObj.regImgs.length));
  }

  startRotate = (currentRotate, index) => {
    this.spinBlinkingLights = true;
    this.wheel.style.transform = `rotate(${currentRotate - index * this.rotate - this.rotate / 2
      }deg)`;
    this.isRotating = false;
    setTimeout(() => {
      this.showWinSeg(index);
    }, 7000);
  };

  showWinSeg(index) {
    let winSegId = document.getElementById(index);
    winSegId.style.backgroundImage = `url(${this.configObj.winImgs[index].imageUrl})`;
    winSegId.classList.add('blink');
    let timeOut = setTimeout(() => {
      winSegId.classList.remove('blink');
      winSegId.style.backgroundImage = (`url(${this.configObj.winImgs[index].imageUrl})`);
      clearTimeout(timeOut);
    }, 3000);
  }

  public Onconfirmation(response) {
    let isAccepted: boolean = false;
    switch (response) {
      case 'accept':
        isAccepted = true;
        this.activeModal.close(isAccepted);
        break;
      case 'decline':
        isAccepted = false;
        this.activeModal.close(isAccepted);
        break;
      case 'dismiss':
        isAccepted = false;
        this.activeModal.dismiss();
        break;
    }
    this.confirmStatus.emit(isAccepted);
  }

}
